// KWB Sold-Out Banner Styles — injected to ensure mobile override
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .kwb-sold-out-banner {
      background-color: #1a1a1a !important;
      border-left: 3px solid #8B6914 !important;
      padding: 16px 20px !important;
      margin: 20px 0 !important;
      border-radius: 2px !important;
    }
    .kwb-sold-out-message {
      color: #cccccc !important;
      font-size: 14px !important;
      margin: 0 0 8px 0 !important;
      line-height: 1.5 !important;
    }
    .kwb-sold-out-message strong {
      color: #ffffff !important;
    }
    .kwb-sold-out-link {
      color: #8B6914 !important;
      font-weight: 600 !important;
      font-size: 14px !important;
      text-decoration: none !important;
      letter-spacing: 0.02em !important;
    }
    .kwb-sold-out-link:hover {
      color: #b5892a !important;
      text-decoration: underline !important;
    }

    .kwb-accordion {
      border: 1px solid rgba(255,255,255,0.15);
     border-radius: 4px;
      padding: 0 20px;
      margin: 12px 0;
    }
    .kwb-accordion:last-of-type {
      border-bottom: 1px solid rgba(255,255,255,0.15);
    }

    .kwb-accordion__trigger {
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
     cursor: pointer;
     list-style: none;
     padding: 16px 0;
     display: flex;
     justify-content: space-between;
     align-items: center;
     color: #8B6914;
    }

    .kwb-accordion__trigger::-webkit-details-marker {
      display: none;
    }

    .kwb-accordion__trigger::after {
      content: '+';
     font-size: 18px;
     font-weight: 300;
     flex-shrink: 0;
     color: #8B6914;
    }

    details[open] .kwb-accordion__trigger::after {
     content: '−';
    }
  `;
  document.head.appendChild(style);
})();

// KWB Variant Pill Hider v4.1 (Updated)
document.addEventListener('DOMContentLoaded', function () {
  // Safer way to get the product handle via Shopify's native meta tags, falling back to URL
  const productHandle = window?.ShopifyAnalytics?.meta?.product?.handle 
    || window.location.pathname.split('/products/')[1]?.split('?')[0];
    
  if (!productHandle) return;

  fetch(`/products/${productHandle}.js`)
    .then(res => {
      if (!res.ok) throw new Error('Product JSON not found');
      return res.json();
    })
    .then(product => {
      applyVisibility(product);
      document.addEventListener('change', function (e) {
        if (e.target.type === 'radio') applyVisibility(product);
      });
    })
    .catch(err => console.warn('KWB variant hider:', err));

  function getCheckedValue(product, optionIndex) {
    const optionKey = `option${optionIndex + 1}`;
    const allValues = [...new Set(product.variants.map(v => v[optionKey]))];
    for (const value of allValues) {
      // Case-insensitive/trimmed match safety can be added here if needed
      const input = document.querySelector(
        `input[type="radio"][value="${CSS.escape(value)}"]:checked`
      );
      if (input) return value;
    }
    return null;
  }

  function setPillVisibility(value, visible) {
    document.querySelectorAll(`input[type="radio"][value="${CSS.escape(value)}"]`)
      .forEach(input => {
        // Find label by 'for' attribute OR look for a parent label element
        const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`) 
          || input.closest('label');
          
        input.style.display = visible ? '' : 'none';
        if (label) label.style.display = visible ? '' : 'none';
      });
    }

  function applyVisibility(product) {
    const variants = product.variants;
    const options = product.options;

    options.forEach((_, optionIndex) => {
      const optionKey = `option${optionIndex + 1}`;
      const allValues = [...new Set(variants.map(v => v[optionKey]))];

      allValues.forEach(value => {
        let isAvailable;

        if (optionIndex === 0) {
          isAvailable = variants.some(v => v[optionKey] === value && v.available);
        } else {
          const primarySelected = getCheckedValue(product, 0);
          isAvailable = variants.some(v => {
            if (!v.available) return false;
            if (v[optionKey] !== value) return false;
            if (primarySelected && v.option1 !== primarySelected) return false;
            return true;
          });
        }

        setPillVisibility(value, isAvailable);
      });
    });
  }
});